<template>
  <ul class="list">
    <li class="list_css" v-on:click="clickList(item.context,item.url,item.id)"
        v-for="item in list" :key="item.id">
      <div class="title_overall_css">
        <div class="help_list_title_css">
          <img src="../../../assets/help/rectangular.png" class="rectangular_css">
          {{ item.title }}
        </div>
        <img src="../../../assets/help/small_arrow.png" class="help_arrow_css">
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'help',
  data () {
    return {
      helpList: [
        // 功能菜单
        {id: 1, title: '常见问题'},
        {id: 2, title: '“音柚”怎么玩？'},
        {id: 3, title: '偶遇匹配问题'},
        {id: 4, title: '聊天攻略'},
        {id: 5, title: '账号与安全'},
      ],
      list: Array
    }
  },
  created () {
    // 初始化
    this.initList()
  },
  methods: {
    initList: function () {
      if (isNaN(this.type)) {
        this.list = []
        this.list = JSON.parse(JSON.stringify(this.helpList))
        document.title = '帮助中心'
      }
    },
    clickList: function (context, name, id) {
      this.$router.push({name: 'BackList', query: {listId: id}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/pomelo/app/Help.vue